import React, { useEffect, useRef } from 'react'
import Switch from '@material-ui/core/Switch';

const SarasSwitchButton2 = (props) => {
    const { value, onClick } = props;

    const [isChecked, setIsChecked] = React.useState(false);
    const onOffRef = useRef();

    const initializeValue = () => {
        if (value && (value === 'on' || value === 'yes' || value === '1'))
            setIsChecked(true)
        else
            setIsChecked(false)
    }

    useEffect(initializeValue, [value])

    const onCheckBoxClick = (e) => {
        const isChecked = e.target.checked;
        setIsChecked(isChecked)
        if (onClick) onClick(onOffRef, isChecked ? '1' : '0')
    }

    return (
        <div style={{display:'inline-block'}}>
            <Switch
                checked={isChecked}
                onChange={onCheckBoxClick}
                color="primary"
                name="checkedB"
                inputProps={{ 'aria-label': 'primary checkbox' }}
            />
        </div>
    )
}

export default SarasSwitchButton2